import React from 'react';
import { Alert, Icon, Menu, Dropdown } from 'antd';

export default class MedicalCapabilityReports extends React.Component {
	render() {
		let routeProps = this.props;
		const brazilMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Brazil/Brazil%20-%20Chapada%20Diamantina%20National%20Park,%20Lencois%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Chapada Diamantina National Park, Lencois</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Brazil/Brazil%20-%20Iguazu%20Falls%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Iguazu Falls</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Brazil/Brazil%20-%20Manaus,%20Careiro%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Manaus, Careiro</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA19_Medcap/Brazil/Brazil%20-%20Rio%20de%20Janiero%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Rio de Janiero </a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA19_Medcap/Brazil/Brazil%20-%20Salvador,%20Praia%20Do%20Forte%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Salvador, Praia Do Forte</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA19_Medcap/Brazil/Brazil%20-%20Valenca,%20Boipeba%20Island,%20Cachoeira%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Valenca, Boipeba Island, Cachoeira </a>
				</Menu.Item>
			</Menu>
		);
		const costaricaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Costa%20Rica/Costa%20Rica-%20Medical%20Capability%20Statement-%20CISI%20-%20SAS%20-%202019%20(1).pdf" target="blank">Costa Rica</a>
				</Menu.Item>
			</Menu>
		);
		const croatiaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Croatia/Croatia%20(Sućuraj_%20Bogomolje_%20Velo%20Grablje_%20Starigrad%20Pakovo%20Selo%20Split%20Drvenik%20Trogir),%20medical%20capability%20statement%202019.docx.pdf" target="blank">Sućuraj, Bogomolje, Velo Grablje, Starigrad, Pakovo, Selo, Split, Drvenik, Trogir</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Croatia/Croatia%20Dubrovnik_%20Orašac_%20Trsteno_%20Kameni%20Dvori%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Dubrovnik, Orašac</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Croatia/Croatia,%20Plitvice%20-%20medical%20capability%20statement%20-%20CISI%202019.docx.pdf" target="blank">Plitvice</a>
				</Menu.Item>
			</Menu>
		);
		const ecuadorMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Buenaventura%20Reserve%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Buenaventura Reserve</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Cuenca%20-%20Medical%20Capability%20Statement-%20CISI%202019.docx.pdf" target="blank">Cuenca</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Dos%20Mangas%20_%20Puerto%20Lopez%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Dos Mangas &amp; Puerto Lopez</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Galapagos%20Island%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Galapagos Island</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Guayaquil-%20Medical%20Capability%20Statement-%20CISI%202019.docx.pdf" target="blank">Guayaquil </a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Isla%20Plata%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Isla de la Plata</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Quito%20-%20Medical%20Capability%20Statement-%20CISI%202019.docx.pdf" target="blank">Quito</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA19_Medcap/Ecuador/Ecuador,%20Salinas%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Salinas</a>
				</Menu.Item>
			</Menu>
		);
		const ghanaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Ghana/Ghana%20-%20Accra,%20Jamestown,%20Fodzoku,%20Shai%20Hills%20Reserve,%20Akyem%20Tafo,%20Aburi,%20Tema,%20Ada%20Foah,%20Akuse,%20Doryumu%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Accra, Jamestown, Fodzoku, Shai Hills Reserve, Akyem Tafo, Aburi, Tema, Ada Foah, Akuse, Doryumu </a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Ghana/Ghana%20-%20Cape%20Coast,%20Elmina,%20Kakum%20National%20Park%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Cape Coast, Elmina, Kakum National Park</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Ghana/Ghana%20-%20Hohoe%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Hohoe</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA19_Medcap/Ghana/Ghana%20-%20Kumasi,%20Mapong,%20Senase%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Kumasi, Mapong, Senase</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA19_Medcap/Ghana/Ghana%20-%20Takoradi,%20Axim,%20Miemia,%20Cape%20Three%20Points,%20Beyin,%20Nzulezu,%20Atomkwa%20Village%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Takoradi, Axim, Miemia, Cape Three Points, Beyin, Nzulezu, Atomkwa Village</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA19_Medcap/Ghana/Ghana%20-%20Tamale,%20Mognori,%20Damongo,%20Mole%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Tamale, Mognori, Damongo, Mole</a>
				</Menu.Item>
			</Menu>
		);
		const montenegroMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Montenegro/Montenegro,%20Perast,%20Budva%20medical%20capability%20statement%20-%20CISI%20-%202019.pdf" target="blank">Budva, Perast, Our Lady of Rocks Island</a>
				</Menu.Item>
			</Menu>
		);

		const moroccoMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Morocco/Asilah,%20Morocco%20-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Asilah</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Morocco/Essaouira%20Morocco_%20El%20Hanchane,%20Morocco%20-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Essaouira, El Hanchane </a>
				</Menu.Item>
				<Menu.Item key="13">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Beni%20Mellal%20-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Beni Mellal</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Casablanca%20-%20Medical%20Capability%20Statement%202019%20(1).pdf" target="blank">Casablanca</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA19_Medcap/Morocco/Morocco,%20El%20Jadida%20-%20Medical%20Capability%20Statement%20-%202019.docx.pdf" target="blank">El Jadida</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Fes_%20Azrou%20-%20Medical%20Capability%20Statement%202019.docx%20(1).pdf" target="blank">Fes, Volubilis, Azrou, Meknes</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Marakesh_%20Ourika_%20Imegdal_Ait%20Ourir%20-%20Medical%20Capability%20Statement%20-%202019.docx%20(1).pdf" target="blank">Marrakech, Ourika, Imegdal, Ait Ourir</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Ouarzazate,%20Ait%20Benhadou%20%20-%20Medical%20Capability%20Statement%20-%202019.docx.pdf" target="blank">Ouarzazate, Ait Benhadou</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Ouled%20Driss%20-%20Medical%20Capability%20Statement%20-%202019.pdf" target="blank">Ouled Driss</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Rabat%20-%20Medical%20Capability%20Statement%20-%202019.docx%20(2).pdf" target="blank">Rabat</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Tetouan,%20Chaouen%20-%20Medical%20Capability%20Statement%202019.docx.pdf" target="blank">Tetouan, Chaouen</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA19_Medcap/Morocco/Morocco,%20Zagora%20-%20Medical%20Capability%20Statement%20-%202019.pdf" target="blank">Zagora</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA19_Medcap/Morocco/Morocco,Zaouiat%20Bouhouta%20%20-%20Medical%20Capability%20Statement%20-%202019.pdf" target="blank">Zaouiat Bouhouta</a>
				</Menu.Item>
				<Menu.Item key="12">
					<a href="/FA19_Medcap/Morocco/Tangier,%20Morocco%20-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Tangier</a>
				</Menu.Item>
			</Menu>
		);
		const peruMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Peru/Peru,%20Cuzco%20-%20Medical%20Capability%20Statement%20-%20CISI%20-%202019.pdf" target="blank">Cuzco</a>
				</Menu.Item>
			</Menu>
		);

		const polandMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Poland/Poland,%20Gdansk-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Gdansk</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Poland/Poland,%20Ketrzyn%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Ketrzyn</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Poland/Poland,%20Krakow%20-%20Medical%20Capability%20Statement-%20CISI%202019%20(1)%20(1).pdf" target="blank">Krakow</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA19_Medcap/Poland/Poland,%20Poznan%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Poznan</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA19_Medcap/Poland/Poland,%20Szymbark%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Szymbark</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA19_Medcap/Poland/Poland,%20Torun%20-%20Medical%20Capability%20Statement-%20CISI%202019.docx.pdf" target="blank">Torun</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA19_Medcap/Poland/Poland,%20Warsaw%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Warsaw</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA19_Medcap/Poland/Poland,%20Wroclaw%20-%20Medical%20Capability%20Statement-%20CISI%202019.pdf" target="blank">Wroclaw</a>
				</Menu.Item>
			</Menu>
		);
		const portugalMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Portugal/Portugal,%20Amoreiras%20-%20Medical%20Capability%20Statement-%202019.pdf" target="blank">Amoreiras</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Portugal/Portugal,%20Evora%20-%20Medical%20Capability%20Statement%20-%202019.pdf" target="blank">Evora</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Portugal/Portugal,%20Lisbon%20-%20Medical%20Capability%20Statement-%202019.pdf" target="blank">Lisbon</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA19_Medcap/Portugal/Portugal,%20Monsanto%20-%20Medical%20Capability%20Statement%20-%202019.pdf" target="blank">Monsanto</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA19_Medcap/Portugal/Portugal,%20Tavira%20-%20Medical%20Capability%20Statement%20-%202019.pdf" target="blank">Tavira</a>
				</Menu.Item>
			</Menu>
		);
		const spainMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Spain/Spain,%20Cadiz-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Cadiz</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Spain/Spain,%20Cordoba-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Cordoba</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Spain/Spain,%20Jerez%20-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Jerez</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA19_Medcap/Spain/Spain,%20Sevilla-%20Medical%20Capability%20Statement%202019%20(1).pdf" target="blank">Sevilla</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA19_Medcap/Spain/Spain,Granada%20-%20Medical%20Capability%20Statement%202019.pdf" target="blank">Granada</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA19_Medcap/Spain/UK,%20Gibraltar%20-%20Medical%20Capability%20Statement%202019.docx.pdf" target="blank">Gibraltar (UK)</a>
				</Menu.Item>
			</Menu>
		);
		const trinidadAndTobagoMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA19_Medcap/Trinidad%20_%20Tobago/Trinidad%20and%20Tobado%20-%20Main%20Ridge%20Forest%20Reserve%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Nariva Swamp, La Brea, San Fernando, Southern tip of Island</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA19_Medcap/Trinidad%20_%20Tobago/Trinidad%20and%20Tobado%20-%20Main%20Ridge%20Forest%20Reserve%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Main Ridge Forest Reserve</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA19_Medcap/Trinidad%20_%20Tobago/Trinidad%20and%20Tobado%20-%20Port%20of%20Spain,%20Arima,%20Maracas,%20Blanchisseuse,%20Piarco%20-%20Medical%20Capability%20Statement-%20CISI%20SAS%20-%202019.pdf" target="blank">Port of Spain, Arima, Maracas, Blanchisseuse, Piarco</a>
				</Menu.Item>
			</Menu>
		);


/*
		//to get pathway, open file from the server in chrome
		const chinaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/China/China,%20Begin%20to%20Believe%20Peak-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Begin to Believe Peak</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/China/China,%20Beijing-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Beijing</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/China/China,%20Chengdu-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Chengdu</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/China/China,%20Great%20Wall-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Great Wall</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/China/China,%20Guilin-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Guilin</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/China/China,%20Huangshan-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Huangshan</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/China/China,%20Huizhou-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Huizhou</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/China/China,%20Miyun-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Miyun</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA18_Medcap/China/China,%20Shanghai-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Shanghai</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA18_Medcap/China/China,%20Tangmo%20Ancient%20Village-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Tangmo Ancient Village</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA18_Medcap/China/China,%20Tunxi-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Tunxi</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA18_Medcap/China/China,%20Xi%E2%80%99an-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Xi'an</a>
				</Menu.Item>
			</Menu>
		);

		const ghanaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Accra-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Accra</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Akuse-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Akuse</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Atomkwa%20Village-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Atomkwa Village</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Berekum-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Berekum</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Beyin-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Beyin</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Cape%20Coast-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cape Coast</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Cape%20Three%20Points-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cape Three Points</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Elmina-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Elmina</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Kakum%20National%20Park-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Kakum National Park</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Miemia%20Beach-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Miemia Beach</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Mount%20Afadjato-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Mount Afadjato</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Nzulezu-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Nzulezu</a>
				</Menu.Item>
				<Menu.Item key="12">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Prince's%20Town-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Prince's Town</a>
				</Menu.Item>
				<Menu.Item key="13">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Senase%20Village-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Sensase Village</a>
				</Menu.Item>
				<Menu.Item key="14">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Shai%20Hills%20Game%20Reserve-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Shai Hills Game Reserve</a>
				</Menu.Item>
				<Menu.Item key="15">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Takoradi-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Takoradi</a>
				</Menu.Item>
				<Menu.Item key="16">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Torgorme%20Village-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Torgorme Village</a>
				</Menu.Item>
				<Menu.Item key="17">
					<a href="/FA18_Medcap/Ghana/Ghana,%20Wli%20Falls-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Wi Falls</a>
				</Menu.Item>
			</Menu>
		);

		const hawaiiMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/HI/Honolulu%20Hawaii%20-%20Provider%20Referrals%202018.pdf" target="blank">Hawaii Provider Referrals</a>
				</Menu.Item>
			</Menu>
		);

		const indiaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/India/India,%20Agra-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Agra</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/India/India,%20Bandhwari-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Bandhwari</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/India/India,%20Bharatpur-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Bharatpur</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/India/India,%20Churmura-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Churmura</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/India/India,%20Jaipur-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Jaipur</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/India/India,%20Kochi-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Kochi</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/India/India,%20Mangar-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Mangar</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/India/India,%20Mathikettan%20Shola%20National%20Park-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Mathikettan Shola National Park</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="h/FA18_Medcap/India/India,%20Mundkayam-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Mundkayam</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA18_Medcap/India/India,%20Munnar-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Munnar</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA18_Medcap/India/India,%20New%20Delhi-%20Medical%20Capability%20Statement%202018.pdf" target="blank">New Delhi</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA18_Medcap/India/India,%20Ranthambore%20National%20Park-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Ranthambore National Park</a>
				</Menu.Item>
				<Menu.Item key="12">
					<a href="/FA18_Medcap/India/India,%20Sarnath-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Sarnath</a>
				</Menu.Item>
				<Menu.Item key="13">
					<a href="/FA18_Medcap/India/India,%20Suryanelli-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Suryanelli</a>
				</Menu.Item>
				<Menu.Item key="14">
					<a href="/FA18_Medcap/India/India,%20Varanasi,%20Uttar%20Pradesh-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Varanasi, Uttar Pradesh</a>
				</Menu.Item>
			</Menu>
		);

		const japanMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Japan/Japan,%20Himeji-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Himeji</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/Japan/Japan,%20Hiroshima-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Hiroshima</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/Japan/Japan,%20Kamakura-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Kamakura</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/Japan/Japan,%20Kobe-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Kobe</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/Japan/Japan,%20Kyoto-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Kyoto</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/Japan/Japan,%20Miyajima%20Island-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Miyajima Island</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/Japan/Japan,%20Mount%20Koya-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Mount Koya</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/Japan/Japan,%20Tokyo-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Tokyo</a>
				</Menu.Item>
			</Menu>
		);

		const mauritiusMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Mauritius/Port%20Louis%20Mauritius%20-%20Medical%20Capability%20Statement%20-2018%20(1).pdf" target="blank">Port Louis</a>
				</Menu.Item>
			</Menu>
		);

		const myanmarMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Amarapura%20-%20Medical%20Capability%20Statement.pdf" target="blank">Amarapura</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Bagan-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Bagan</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Bago-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Bago</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Gwa%20-%20Medical%20Capability%20Statement.pdf" target="blank">Gwa</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20He-Hoe-%20Medical%20Capability%20Statement%202018.pdf" target="blank">He-Hoe</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Hpa%20An-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Hpa An</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Hpa%20Ouk-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Hpa Ouk</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Kalaw-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Kalaw</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Mandalay-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Mandalay</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Mawlamyine-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Mawlamyine</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Nyaung%20Gyi%20and%20Taung%20Kong-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Nyaung Gyi and Taung Kong</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Nyaung%20U%20-%20Medical%20Capability%20Statement.pdf" target="blank">Nyaung U</a>
				</Menu.Item>
				<Menu.Item key="12">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Rakhine%20Yoma%20Elephant%20Range%20-%20Medical%20Capability%20Statement.pdf" target="blank">Rakhine Yoma Elephant Range</a>
				</Menu.Item>
				<Menu.Item key="13">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Thandwe%20-%20Medical%20Capability%20Statement.pdf" target="blank">Thandwe</a>
				</Menu.Item>
				<Menu.Item key="14">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Thaton%20-%20Medical%20Capability%20Statement.pdf" target="blank">Thaton</a>
				</Menu.Item>
				<Menu.Item key="15">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20U%20Nar%20Auk-%20Medical%20Capability%20Statement%202018.pdf" target="blank">U Nar Auk</a>
				</Menu.Item>
				<Menu.Item key="16">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Yandabo%20-%20Medical%20Capability%20Statement.pdf" target="blank">Yandabo</a>
				</Menu.Item>
				<Menu.Item key="17">
					<a href="/FA18_Medcap/Myanmar/Myanmar,%20Yangon-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Yangon</a>
				</Menu.Item>
			</Menu>
		);

		const southAfricaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/South%20Africa/Botswana,%20Chobe%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Botswanam, Chobe</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/South%20Africa/Botswana,%20Zambezi%20River%20-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Botswana, Zambezi River</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Botlierskop%20Game%20Reserve%20-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Botlierskop Game Reserve</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Cape%20Town%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cape Town</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Fairy%20Glen%20Private%20Game%20Reserve%20%20-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Fairy Glen Private Game Reserve</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Johannesburg%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Johannesburg</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Kapama%20Private%20Game%20Reserve%20-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Kapama Private Game Reserve</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Mabula%20Game%20Reserve%20-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Mabula Game Reserve</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Maropeng%20-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Maropeng</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Sterkfontein%20Caves%20%20-%20Medical%20Capability%20Statement%202018%20V2.pdf" target="blank">Sterkfontein Caves</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA18_Medcap/South%20Africa/South%20Africa,%20Tambo%20Village%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Tambo Village</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA18_Medcap/South%20Africa/Zimbabwe,%20Victoria%20Falls%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Zimbabwe, Victoria Falls</a>
				</Menu.Item>
			</Menu>
		);

		const spainMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Spain/Spain,%20Barcelona-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Barcelona</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/Spain/Spain,%20Bilbao-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Bibao</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/Spain/Spain,%20Cordoba-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cordoba</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/Spain/Spain,%20Gernika-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Gernika</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/Spain/Spain,%20Getxo-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Getxo</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/Spain/Spain,%20Granada-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Granada</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/Spain/Spain,%20Madrid-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Madrid</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/Spain/Spain,%20Sevilla-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Sevilla</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA18_Medcap/Spain/Spain,%20Valencia-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Valencia</a>
				</Menu.Item>
			</Menu>
		);
		//test
		const vietnamMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Vietnam/Cambodia,%20Kampong%20Khleang-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cambodia, Kampong Khleang</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_Medcap/Vietnam/Cambodia,%20Phnom%20Penh-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cambodia, Phnom Penh</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/Vietnam/Cambodia,%20Siem%20Reap-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cambodia, Siem Reap</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Anh%20Binh-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Anh Binh</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Cai%20Son-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Cai Son</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Ha%20Long%20Bay-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Ha Long Bay</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Hanoi-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Hanoi</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Ho%20Chi%20Minh%20City-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Ho Chi Minh City</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Nam%20Cat%20Tien%20National%20Park%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Nam Cat Tien National Park</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Sa%20P%E1%BA%A3%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Sa Pa</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Ta%20Lai-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Ta Lai</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Tuan%20Chau%20Island-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Tuan Chau Island</a>
				</Menu.Item>
				<Menu.Item key="12">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Viet%20Hai%20Village%20-%20Medical%20Capability%20Statement%202018.pdf" target="blank">Viet Hai Village</a>
				</Menu.Item>
				<Menu.Item key="13">
					<a href="/FA18_Medcap/Vietnam/Vietnan,%20Cai%20Thia%20Village%20%20-Medical%20Capability%20Statement%202018.pdf" target="blank">Cai thia Village</a>
				</Menu.Item>
				<Menu.Item key="14">
					<a href="/FA18_Medcap/Vietnam/Vietnam,%20Cai%20Be,%20Ben%20Tre-%20Medical%20Capability%20Statement%202019.pdf" target="blank">CaiBe and Ben Tre</a>
				</Menu.Item>
			</Menu>
		);

		const moroccoMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_MedCap/Morocco/Ait%20Benhadou%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Ait Benhadou</a>
				</Menu.Item>
				<Menu.Item key="1">
					<a href="/FA18_MedCap/Morocco/Casablanca%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Casablanca</a>
				</Menu.Item>
				<Menu.Item key="2">
					<a href="/FA18_Medcap/Morocco/Chaouen%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Chaouen</a>
				</Menu.Item>
				<Menu.Item key="3">
					<a href="/FA18_Medcap/Morocco/El%20Jadida%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">El Jadida</a>
				</Menu.Item>
				<Menu.Item key="4">
					<a href="/FA18_Medcap/Morocco/Essaouira%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Essaouira</a>
				</Menu.Item>
				<Menu.Item key="5">
					<a href="/FA18_Medcap/Morocco/Fes%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Fes</a>
				</Menu.Item>
				<Menu.Item key="6">
					<a href="/FA18_Medcap/Morocco/Marrakech%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Marrakech</a>
				</Menu.Item>
				<Menu.Item key="7">
					<a href="/FA18_Medcap/Morocco/Meknes%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Meknes</a>
				</Menu.Item>
				<Menu.Item key="8">
					<a href="/FA18_Medcap/Morocco/Ouarzazate%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Quarzazate</a>
				</Menu.Item>
				<Menu.Item key="9">
					<a href="/FA18_Medcap/Morocco/Rabat%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Rabat</a>
				</Menu.Item>
				<Menu.Item key="10">
					<a href="/FA18_Medcap/Morocco/Tahannaout%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Tahannaout</a>
				</Menu.Item>
				<Menu.Item key="11">
					<a href="/FA18_Medcap/Morocco/Volubilis%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Volubilis</a>
				</Menu.Item>
				<Menu.Item key="12">
					<a href="/FA18_Medcap/Morocco/Zagora%20Morocco%20-%20Medical%20Capability%20Statement.pdf" target="blank">Zagora</a>
				</Menu.Item>
			</Menu>
		);

		const ensenadaMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Ensenada/Med%20Cap%20-ENSENADA.pdf" target="blank">Ensenada</a>
				</Menu.Item>
			</Menu>
		);

		const netherlandsMenu = (
			<Menu>
				<Menu.Item key="0">
					<a href="/FA18_Medcap/Netherlands/Netherlands%20Amsterdam%20-%20Medical%20Capability%20Statement%20-2019.pdf" target="blank">Amsterdam</a>
				</Menu.Item>
			</Menu>
		);
*/
		return (
			<div>
				<Alert showIcon type="info"
					description={<span>
						Medical Capability Network through our Insurance provider AXA has prepared Capability Statements which it has provided to Semester at Sea in connection with the planned call of the Vessel to Spain, Ghana, South Africa, Mauritius, India, Myanmar, Vietnam, China, Japan.
						<br />
						<br />
						Included in the Medical Capability Statement is Section 3 – Medical Information.
						<br />
						<br />
						The facts underlying the report may change, and thus the current information may not be accurate from time to time, and may lead to different analysis.
						<br />
						<br />
						Semester at Sea makes no guarantees as to the accuracy, either currently or in the future, of this report.  Semester at Sea of course exercises reasonable best efforts to remain current, consistent with information provided by Medical Capability Network and the US State Department.
					</span>} />
				<br />

			<h1>Brazil</h1>
				<Dropdown overlay={brazilMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
						Medical Capability Reports Brazil  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Costa Rica</h1>
				<Dropdown overlay={costaricaMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Costa Rica  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Croatia</h1>
				<Dropdown overlay={croatiaMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Croatia  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Ecuador</h1>
				<Dropdown overlay={ecuadorMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Ecuador  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Ghana</h1>
				<Dropdown overlay={ghanaMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Ghana  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Montenegro</h1>
				<Dropdown overlay={montenegroMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Montenegro  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Morocco</h1>
				<Dropdown overlay={moroccoMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Morocco  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Peru</h1>
				<Dropdown overlay={peruMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Peru  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Poland</h1>
				<Dropdown overlay={polandMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Poland  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Portugal</h1>
				<Dropdown overlay={portugalMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Portugal  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Spain</h1>
				<Dropdown overlay={spainMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Spain  <Icon type="caret-down" />
					</a>
				</Dropdown>
				<br />
				<br />
				<h1>Trinidad &amp; Tobago</h1>
				<Dropdown overlay={trinidadAndTobagoMenu} trigger={['click']}>
					<a className="ant-dropdown-link" href="#" style={{fontSize: '1.2em'}}>
					Medical Capability Reports Trinidad &amp; Tobago  <Icon type="caret-down" />
					</a>
				</Dropdown>

			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Safety/MedicalCapabilityReports.jsx